import React from 'react';
import { Dialog, DialogContent, DialogActions, Button, Box, Typography } from '@mui/material';
import BlockIcon from '@mui/icons-material/Block';
import RestoreIcon from '@mui/icons-material/Restore';

const TemporaryDisableAccessDialog = ({
  open,
  partnerName,
  isCurrentlyDisabled = false,
  submitting = false,
  onClose,
  onConfirm,
}) => {
  const isRestore = Boolean(isCurrentlyDisabled);

  return (
    <Dialog
      open={open}
      onClose={submitting ? undefined : onClose}
      PaperProps={{
        sx: {
          borderRadius: 2,
          p: 2,
          textAlign: 'center',
          maxWidth: 400,
          width: '100%',
        },
      }}
    >
      <DialogContent sx={{ pb: 1, pt: 1 }}>
        <Box
          sx={{
            width: 60,
            height: 60,
            borderRadius: '50%',
            bgcolor: isRestore ? '#ecfdf3' : '#fce8e6',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 'auto',
            mb: 2,
          }}
        >
          {isRestore ? (
            <RestoreIcon sx={{ fontSize: 32, color: '#16a34a' }} />
          ) : (
            <BlockIcon sx={{ fontSize: 32, color: '#f44336' }} />
          )}
        </Box>
        <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
          {isRestore ? 'Restore partner access?' : 'Temporarily disable access?'}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
          {isRestore ? (
            <>
              Restore portal access for{' '}
              <Box component="span" sx={{ fontWeight: 600, color: 'text.primary' }}>
                {partnerName || 'this partner'}
              </Box>
              ? They will be able to sign in and manage their community again.
            </>
          ) : (
            <>
              Temporarily disable portal access for{' '}
              <Box component="span" sx={{ fontWeight: 600, color: 'text.primary' }}>
                {partnerName || 'this partner'}
              </Box>
              ? They will not be able to sign in until access is restored.
            </>
          )}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', gap: 2, pb: 1, pt: 2 }}>
        <Button
          variant="outlined"
          onClick={onClose}
          disabled={submitting}
          sx={{ minWidth: 100, textTransform: 'none' }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color={isRestore ? 'success' : 'error'}
          onClick={onConfirm}
          disabled={submitting}
          sx={{ minWidth: 100, textTransform: 'none' }}
        >
          {submitting
            ? isRestore
              ? 'Restoring…'
              : 'Disabling…'
            : isRestore
              ? 'Restore'
              : 'Disable'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TemporaryDisableAccessDialog;
